export const CreditReviewPages = {
	CreditReviewQueue: {
		name: "credit-review",
		displayName: "Credit Review Queue",
	},
	CreditReviewDetails: {
		displayName: "Details",
	},
	CreditReview: {
		name: "credit-review",
		displayName: "Credit Review",
	},
};
